

const app = angular.module('msi.upsell', [
  require('./shipment-upsell'),
  require('./no-shipments-upsell')
]);

module.exports = app.name;
